import { render } from "./dirEdit.vue?vue&type=template&id=40917d04"
import script from "./dirEdit.vue?vue&type=script&lang=ts"
export * from "./dirEdit.vue?vue&type=script&lang=ts"
script.render = render

export default script